<template>
    <div class="pt-2">
        <div class="col-sm-12">
            <Transition name="fade">
                <inspectable-list
                    v-if="!editMode"
                    :results="results"
                    @add="addInspectable"
                    @edit="editInspectable"
                />
            </Transition>
            <Transition name="fade">
                <base-modal
                    v-if="editMode && inspectable"
                    size="lg"
                    :hide-header="true"
                    :hide-footer="true"
                >
                    <inspectable-editor
                        :inspectable="inspectable"
                        @close="showInspectablesList"
                        @closeAndUpdate="closeAndUpdate"
                    />
                </base-modal>
            </Transition>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {inspectionHelper} from '../../mixins/InspectionMixin'
import InspectableList from './InspectableList'
import InspectableEditor from './InspectableEditor'
import BaseModal from "@/components/BaseModal";

export default {
    name: 'Inspectables',
    components: {BaseModal, InspectableList, InspectableEditor},
    mixins: [restApi, inspectionHelper],
    data: function () {
        return {
            results: [],
            inspectable: null,
            editMode: false,
            loading: true
        }
    },
    mounted: function () {
        this.fetchInspectables()
    },
    methods: {
        fetchInspectables: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.inspectableUrl, this.handleResponse)
        },

        handleResponse: function (response) {
            this.loading = false
            if (response?.data) {
                response.data.sort((a, b) => a.name.localeCompare(b.name));
                this.results = response.data
            }
        },

        addInspectable: function () {
            this.inspectable = this.newInspectable()
            this.editMode = true
        },
        editInspectable: function (inspectable) {
            this.inspectable = inspectable
            this.editMode = true
        },
        showInspectablesList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchInspectables()
            this.showInspectablesList()
        }

    }
}
</script>
